import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MoredetailsListComponent } from './moredetails-list/moredetails-list.component';
import { MoredetailsCreateComponent } from './moredetails-create/moredetails-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: MoredetailsListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: MoredetailsCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'moredetails-create/:id',
        component: MoredetailsCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MoredetailsRoutingModule { }
